import React from 'react'

import Layout from '../components/layout'
import Intro from '../components/index/welcome'
import About from '../components/index/about'
import All from '../components/index/all'
import Team from '../components/index/team'
import Services from '../components/index/services'
import Contact from '../components/index/contact'
import Prodcuts from '../components/index/products'
import Gallery from '../components/index/gallery';

export default ({ data }) => {
  return (
    <Layout>
      <Intro />
      <main id='main' >
        <Gallery />
        <About />
        <Services />
        <Prodcuts />
        <All />
        {/* <Team /> */}
        <Contact />
      </main>
    </Layout>
  )
}